/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react'

export default createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClose: (reason?: 'backdropClick' | 'escapeKeyDown') => {},
})
